// Component Modal tái sử dụng — render qua portal để escape stacking context
// (sidebar có z-50 tạo stacking → modal z-[10000] inline bị clip).
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import clsx from 'clsx';

// `bodyClassName`: lề của thân hộp (mặc định px-6 py-4). Hộp tự dựng thanh dính đầu/đáy + nền riêng (vd «Cài đặt lịch»:
// tab dính trên, nền xám sau thẻ như trang cài đặt, nút Lưu dính dưới) truyền 'p-0' rồi tự lo lề.
export default function Modal({ isOpen, onClose, title, children, size = 'md', bodyClassName = 'px-6 py-4' }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    if (isOpen) document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [isOpen, onClose]);

  // Khoá scroll trang nền khi modal mở — tránh trang chính bị cuộn cùng modal
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [isOpen]);

  if (!isOpen) return null;

  const sizes = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl',
  };

  return createPortal(
    <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className={clsx('relative bg-white rounded-xl shadow-xl w-full flex flex-col max-h-[92vh]', sizes[size])}>
        <div className="flex items-center justify-between px-6 py-4 border-b shrink-0">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button onClick={onClose} className="p-1 rounded-lg hover:bg-gray-100 transition-colors">
            <X size={18} />
          </button>
        </div>
        <div className={clsx('overflow-y-auto flex-1 min-h-0', bodyClassName)}>
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}
